import { css } from 'linaria';
import { styled } from 'linaria/react';

export const creditLinkStyle = css`
  display: inline-block;
  color: var(--brand-dark);

  &:hover {
    color: var(--control-hover-accent);
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  column-gap: 24px;

  @media (--only-desktop) {
    grid-template-columns: repeat(3, 1fr);
    row-gap: 32px;
    column-gap: 128px;
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(3, 1fr);
    row-gap: 24px;
    column-gap: 16px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    row-gap: 24px;
  }
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
`;

export const ListItemIcon = styled.img`
  width: 100px;
  height: 100px;
  margin-right: 24px;

  @media (--to-desktop) {
    width: 80px;
    height: 80px;
    margin-right: 16px;
  }

  @media (--only-mobile) {
    width: 48px;
    height: 48px;
  }
`;

export const sectionSubtitleStyle = css`
  margin-bottom: 47px;

  @media (--to-desktop) {
    margin-bottom: 32px;
  }

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

export const benefitsItem = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  flex: 1 0 0;
  gap: 16px;
`;
